import { Injectable } from '@angular/core';
import { ICellularDeviceAssignmentService } from './services';
import { ProxyService } from '../proxy/ProxyService';

@Injectable({
    providedIn: 'root'
})
export class CellularDeviceAssignmentService implements ICellularDeviceAssignmentService {
    public static $name: string = 'cellularDeviceAssignmentService';

    private _assignments: CASLink.Device.Ui.ViewModel.Modules.CellularDeviceAssignmentViewModel[];

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getCellularDeviceAssignments(): angular.IPromise<CASLink.Device.Ui.ViewModel.Modules.CellularDeviceAssignmentViewModel[]> {
        if (this._assignments) {
            return Promise.resolve(this._assignments);
        } else {
            return this.initialize();
        }
    }

    private initialize(): angular.IPromise<CASLink.Device.Ui.ViewModel.Modules.CellularDeviceAssignmentViewModel[]> {
        return this.proxyService.request({
            endPoint: 'cellularDeviceAssignments',
            route: 'getCellularDeviceAssignments',
        }).asArray<CASLink.Device.Ui.ViewModel.Modules.CellularDeviceAssignmentViewModel>()
            .then((result: CASLink.Device.Ui.ViewModel.Modules.CellularDeviceAssignmentViewModel[]) => {
                this._assignments = result;
                return result;
            });
    }
}
